import { RetailerWrapper } from "../styles";
import { Button } from "@/common/components/button";
import {
  getUserManagementTableData,
  userManagementTableHeaders,
  userManagementTableKeys,
  getRoleManagementTableData,
  roleManagementTableHeaders,
  roleManagementTableKeys,
  invitationForm,
} from "./data";
import Table from "@/common/components/Table";
import { Pagination } from "@/common/components/pagination";
import { KeyValueObj } from "@/common/types";
import { useCallback, useMemo, useState } from "react";
import useQuery from "@/hooks/useQuery";
import { DELIVERY_REQUEST_URLS } from "@/common/constants";
import { Modal } from "@/common/components/modal";
import Form from "@/common/components/form/Form";
import { Prompt } from "@/common/components/prompt";
import Tab2 from "@/common/components/Tab/Tab2";
import { userManagementCards } from "./data";
import { LargeCard } from "../../stats/subs/LargeCard";

const DRFUser = () => {
  const [currentRow, setCurrentRow] = useState<KeyValueObj>({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentTab, setCurrentTab] = useState("User");
  const [rolePerpage, setRolePerpage] = useState(25);
  const [userPerpage, setUserPerpage] = useState(25);
  const [showViewModal, setShowViewModal] = useState(false);
  const [inviteModal, setInviteModal] = useState(false);

  const {
    data: userManagement,
    meta: userManagementMeta,
    loading: userLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${userPerpage}&page=${userPerpage}`
  );

  const {
    data: roleManagement,
    meta: roleManagementMeta,
    loading: roleLoading,
  } = useQuery(
    DELIVERY_REQUEST_URLS +
      `/incoming-requests?per_page=${rolePerpage}&page=${rolePerpage}`
  );

  const handleDropdownClick = useCallback(
    (row: KeyValueObj) => {
      const willShow = !showDropdown;
      const newRow = willShow ? row : {};

      setCurrentRow(newRow);
      setShowDropdown(willShow);
    },
    [showDropdown]
  );

  const handleUserView = useCallback(() => {
    setShowViewModal(true);
  }, []);

  const userDropdowns = useMemo(
    () =>
      currentRow?.userStatus?.value !== "active"
        ? [{ label: "Activate", action: handleUserView }]
        : [{ label: "Deactivate", action: handleUserView }],
    [handleUserView, currentRow]
  );

  const handleViewRole = useCallback(() => {
    alert("coming soon");
  }, []);

  const roleDropdowns = useMemo(
    () =>
      currentRow?.trackingID?.value !== "--"
        ? [{ label: "View", action: handleViewRole }]
        : [{ label: "View", action: handleViewRole }],
    [handleViewRole, currentRow?.trackingID?.value]
  );

  const handleInviteSubmit = () => {
    alert("Form submitted");
  };

  const userStatus = () => {
    return currentRow?.userStatus?.value === "active";
  };

  const tabs = [
    {
      title: "User",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={userManagementTableHeaders}
            tableKeys={userManagementTableKeys}
            tableData={getUserManagementTableData(userManagement)}
            tableTitle="List of all users"
            tableSubtitle={(userManagementMeta?.total_count ?? "0") + " users"}
            loading={userLoading}
            handleDropDownClicked={handleDropdownClick}
            showDropDown={showDropdown}
            dropDownOptions={userDropdowns}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={userManagementMeta?.total_pages}
            onNextPage={(event: any) => setUserPerpage(event.selected)}
            onPerPageChange={(event: any) =>
              setUserPerpage(event?.target?.value)
            }
          />
        </div>
      ),
    },
    {
      title: "Role",
      component: (
        <div className="table-wrapper">
          <Table
            tableHeaders={roleManagementTableHeaders}
            tableKeys={roleManagementTableKeys}
            tableData={getRoleManagementTableData(roleManagement)}
            tableTitle="Role allocation history"
            loading={roleLoading}
            handleDropDownClicked={handleDropdownClick}
            showDropDown={showDropdown}
            dropDownOptions={roleDropdowns}
            spaced
            rowLineColor="light"
          />
          <Pagination
            pageCount={roleManagementMeta?.total_pages}
            onNextPage={(event: any) => setRolePerpage(event.selected)}
            onPerPageChange={(event: any) =>
              setRolePerpage(event?.target?.value)
            }
          />
        </div>
      ),
    },
  ];

  return (
    <RetailerWrapper>
      {/* card wrapper */}
      <div className="card-wrapper">
        {userManagementCards?.map((card: any) => (
          <LargeCard
            color={card?.color}
            icon={card.icon}
            value={card.value}
            title={card.name}
          />
        ))}
      </div>
      <div>
        <div className="top-wrapper">
          <Button onClick={() => setInviteModal(true)}>Invite New User</Button>
        </div>
      </div>
      <Modal
        title="User Invitation"
        isOpen={inviteModal}
        close={() => setInviteModal(false)}
      >
        <div className="modal">
          <Form
            formInputs={invitationForm}
            processInputs={handleInviteSubmit}
          />
        </div>
      </Modal>
      <Tab2
        onTabClick={(tab: string) => setCurrentTab(tab)}
        currentTab={currentTab}
        tabs={tabs}
      />
      <Modal isOpen={showViewModal} close={() => setShowViewModal(false)}>
        <Prompt
          prompt={`Are you sure you want to ${
            userStatus() ? "deactivate" : "activate"
          } user`}
          type={userStatus() ? "delete" : "accept"}
          onMainAction={(_?: any) => {
            alert("coming soon");
          }}
          onSecondaryAction={() => setShowViewModal(false)}
        />
      </Modal>
    </RetailerWrapper>
  );
};

export default DRFUser;
